import type { EmissionControl } from '@/services/integrations';

/** Status em que o controle espera alguém informar o nº da apólice emitida no i4Pro. */
export const AWAITING_MANUAL_EMISSION_STATUS = 'awaiting_manual_emission';

/**
 * O controle está esperando uma ação manual?
 *
 * Decide pelo ESTADO do controle, não pelo modo ATUAL do produto: a proposta
 * transmitida enquanto o produto estava em MANUAL continua esperando mesmo que a
 * área volte o produto para INTEGRATION depois — senão ela ficaria órfã, porque
 * a emissão automática não varre esse status. É a mesma regra do BFF.
 *
 * Depois que o número é informado o status muda, e a retomada passa a ser pelo
 * "Reprocessar", que não pede o número de novo.
 */
export function isAwaitingManualEmission(
  control?: Pick<EmissionControl, 'status'> | null
): boolean {
  return control?.status === AWAITING_MANUAL_EMISSION_STATUS;
}
